export default __webpack_public_path__ + "static/media/ui_visual_indicator_cube.1fd7fede.png";